import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './style.scss';

const Modal = ({ children, hideCloseButton, onClose }) => {
  const modalRoot = document.getElementById('modal-root');

  useEffect(() => {
    const keyListener = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', keyListener);

    return () => window.removeEventListener('keydown', keyListener);
  }, [onClose]);

  const content = (
    <div className="Modal">
      {!hideCloseButton && (
        <a
          aria-label="Close button"
          className="Modal--close-button"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}>
          <div className="icon-before icon-plus icon-variant-4 icon-rotate-45" />
        </a>
      )}
      <div
        className="Modal--content"
        onClick={(e) => {
          if (e.target.className === 'Modal--content') {
            onClose();
          }
        }}>
        {children}
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    content,
    modalRoot,
  );
};

export default Modal;
